<template>
    <span class="close-modal-btn" @click="closeModal">
        X
    </span>
</template>

<script>

export default {
    methods: {
        closeModal() {
            this.$root.$emit('closeModal');
        }
    }
}

</script>

<style scoped lang="scss">

.close-modal-btn {
    position: absolute;
    top: 20px;
    right: 15px;
    cursor: pointer;
    font-weight: bold;
    font-size: 120%;
}

</style>


// WEBPACK FOOTER //
// ModalCloseButton.vue?08fc89f4